import React, { useEffect, useState } from 'react';
import { redirectToSignIn, refresh } from './api';

const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [authed, setAuthed] = useState(false);

    useEffect(() => {
        refresh().then((ok) => (ok ? setAuthed(true) : redirectToSignIn()));
    }, []);

    return authed ? <>{children}</> : null;
};

export default AuthGate;
